module.exports = __webpack_public_path__ + "static/img/ios_th.8d0069c1.png";